import { useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useSidebar } from '@/components/ui/sidebar';
import { SinoNotificacoes } from './SinoNotificacoes';
import { tituloDaRota } from './navegacao';

// Barra de topo do app (celular): menu, título da tela e sino. Respeita o
// notch/ilha do iPhone pelo safe-area do topo.
export function AppBar({ titulo }: { titulo?: string }) {
  const { pathname } = useLocation();
  const { setOpenMobile } = useSidebar();

  return (
    <header className="sticky top-0 z-30 shrink-0 border-b border-border/60 bg-bg-main/95 pt-[env(safe-area-inset-top)] backdrop-blur supports-[backdrop-filter]:bg-bg-main/80">
      <div className="flex h-14 items-center gap-1 px-2">
        <button
          type="button"
          onClick={() => setOpenMobile(true)}
          aria-label="Abrir menu"
          className="flex size-11 items-center justify-center rounded-full text-text-secondary transition-colors active:bg-muted"
        >
          <Menu size={22} />
        </button>
        <h1 className="min-w-0 flex-1 truncate text-[17px] font-semibold text-text-title">
          {titulo ?? tituloDaRota(pathname)}
        </h1>
        <SinoNotificacoes />
      </div>
    </header>
  );
}
